import React, { useContext, useEffect, useState } from "react";
import { MainTitle, Wrapper } from "./styles";
import { Route, Routes, Navigate } from "react-router-dom";
import useBasenamePath from "../../utils/useBasenamePath";
import LoginPopup from "../../components/LoginPopup/LoginPopup";
import { LanguageContext } from "@eriksdigital/atomic-ui/components";
import { useRaffaella } from "@eriksdigital/raffaella";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";
import CategoriesScreen from "../../components/CategoriesScreen";
import CustomizerScreen from "../../components/CustomizerScreen";

const AppContainer: React.FC = () => {
  const basenamePath = useBasenamePath();
  const [user] = useRaffaella("user");
  const { erpSystem } = useContext<any>(LanguageContext);

  const [showLoginPopup, setShowLoginPopup] = useState<boolean | null>(null);
  const intl = useIntl();

  useEffect(() => {
    if (
      !!user.data &&
      typeof user.data.isGuestUser !== "undefined" &&
      typeof user.data.loggedIn !== "undefined"
    ) {
      setShowLoginPopup(!(user.data.loggedIn && !user.data.isGuestUser));
    }
  }, [user.data, erpSystem]);

  const handleLogin = () => {
    window.location.href = user.data.loginUrl;
  };

  const handleWithoutLogin = () => {
    setShowLoginPopup(false);
  };

  const getTitleByCountry = () => {
    switch (erpSystem) {
      case "ch": {
        //Specific title for POC EGS-3732
        return intl.formatMessage({
          id: "title.ch",
          defaultMessage: "Plastics Configurator",
          description: "Label of Title of the page"
        });
      }
      default: {
        return intl.formatMessage({
          id: "title",
          defaultMessage: "Plastics Configurator",
          description: "Label of Title of the page"
        });
      }
    }
  };

  return (
    <Wrapper>
      <Helmet>
        <title>{getTitleByCountry()}</title>
      </Helmet>
      <MainTitle>{getTitleByCountry()}</MainTitle>
      <Routes>
        <Route
          path={basenamePath}
          element={<Navigate to={`${basenamePath}/categories`} replace />}
        />
        <Route
          path={`${basenamePath}/categories`}
          element={<CategoriesScreen />}
        />
        <Route
          path={`${basenamePath}/categories/:basicForm`}
          element={<CustomizerScreen />}
        />
        <Route
          path={`${basenamePath}/categories/:basicForm/:id`}
          element={<CustomizerScreen />}
        />
        <Route path="*" element={<Navigate to={basenamePath} replace />} />
      </Routes>
      {showLoginPopup === true && (
        <LoginPopup onLogin={handleLogin} onWithoutLogin={handleWithoutLogin} />
      )}
    </Wrapper>
  );
};

export default AppContainer;
